import { render, staticRenderFns } from "./ObjectTree.vue?vue&type=template&id=3f22b32a&shadow"
import script from "./ObjectTree.vue?vue&type=script&lang=js&shadow"
export * from "./ObjectTree.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ObjectTree.vue?vue&type=style&index=0&id=3f22b32a&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports